import { FilterCategory, SearchFilterBase, SearchFilterType } from '../types';

export default function relevancyFilterConfig(): SearchFilterBase {
  return {
    name: 'Relevancy',
    icon: 'diamond',
    disabled: true,
    comingSoon: true,
    index: 22,
    utils: {
      tags: {
        config: {
          showAsCard: true,
          tagsCardTitle: 'Relevancy',
        },
      },
    },
    type: SearchFilterType.ROOT,
    category: [FilterCategory.COMPANY_DATA],
    items: [
      {
        name: 'Relevancy',
        type: SearchFilterType.CHECK_BOX,
        icon: undefined,
        index: 0,
        key: 'relevancy',
        field: 'relevancy',
        metadata: {
          availability: {
            requires: ['value'],
            required: true,
            info: {
              Company:
                'The Relevance filter is only functional when at least one lookalike domain has been added to the Search. You can conduct a domain search by adding at least one domain either via the search results or in the search panel at the top.',
              People: '',
              Employees: '',
              BuyingTeam: '',
            },
          },
          hideTags: true,
          skipUrlParams: true,
        },
        config: { labelKey: 'label', valueKey: 'value' },

        options: [
          {
            type: 'STRING',
            value: 'A',
            label: 'Very high relevance',
            icon: '/assets/icons/relevancy/A.svg',
            index: 1,
            selected: true,
          },
          {
            type: 'STRING',
            value: 'B',
            label: 'High relevance',
            icon: '/assets/icons/relevancy/B.svg',
            index: 2,
            selected: true,
          },
          {
            type: 'STRING',
            value: 'C',
            label: 'Medium relevance',
            icon: '/assets/icons/relevancy/C.svg',
            index: 3,
            selected: true,
          },
          {
            type: 'STRING',
            value: 'D',
            label: 'Low relevance',
            icon: '/assets/icons/relevancy/D.svg',
            index: 4,
            selected: true,
          },
        ],
      },
    ],
  };
}
